<div [formGroup]="controlFormGroup" class="margin-bottom-1">
  <label>{{ controlName | snakeCaseToHuman | uppercase }}</label>
  <textarea [froalaEditor]="froalaEditorOptions" [formControlName]="controlName"></textarea>
</div>

<rav-field-errors
  [controlFormGroup]="controlFormGroup"
  [controlName]="controlName"
  [hasErrors]="hasErrors()"
></rav-field-errors>
